"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";
import Image from "./webflow_modules/Basic/components/Image";
import Link from "./webflow_modules/Basic/components/Link";
import * as _interactions from "./webflow_modules/interactions";

const _interactionsData = JSON.parse(
  '{"events":{"e":{"id":"e","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-4"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"13d79344-ebcb-e42a-9e0a-ca3e760a9bf2","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"13d79344-ebcb-e42a-9e0a-ca3e760a9bf2","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1701565477262},"e-2":{"id":"e-2","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-2","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-3"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"13d79344-ebcb-e42a-9e0a-ca3e760a9bf2","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"13d79344-ebcb-e42a-9e0a-ca3e760a9bf2","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1701565477262}},"actionLists":{"a":{"id":"a","title":"Hero Card - on - hover","actionItemGroups":[{"actionItems":[{"id":"a-n","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"13d79344-ebcb-e42a-9e0a-ca3e760a9bf2"},"globalSwatchId":"","rValue":46,"bValue":46,"gValue":46,"aValue":1}}]},{"actionItems":[{"id":"a-n-2","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"inOutQuad","duration":100,"target":{"useEventTarget":true,"id":"13d79344-ebcb-e42a-9e0a-ca3e760a9bf2"},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":1}}]}],"useFirstGroupAsInitialState":true,"createdOn":1701565487896},"a-2":{"id":"a-2","title":"Hero Card - on - hover 2","actionItemGroups":[{"actionItems":[{"id":"a-2-n-2","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"inOutQuad","duration":100,"target":{"useEventTarget":true,"id":"13d79344-ebcb-e42a-9e0a-ca3e760a9bf2"},"globalSwatchId":"","rValue":46,"bValue":46,"gValue":46,"aValue":1}}]}],"useFirstGroupAsInitialState":false,"createdOn":1701565487896}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function HeroSubCardComponent({
  description = "Schedule rent payments, submit maintenance requests, renew your lease and more.",
  icon = "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/656bd2a03bf3058f0b5261d9_residents.svg",

  linkLink = {
    href: "#",
  },

  linkText = "Locations",
  title = "Careers",
}) {
  _interactions.useInteractions(_interactionsData);

  return (
    <Block className={"subhero-card-component"} tag={"div"}>
      <Block
        className={"subhero-card"}
        data-w-id={"13d79344-ebcb-e42a-9e0a-ca3e760a9bf2"}
        tag={"div"}
      >
        <Block className={"subhero-card-copy-block"} tag={"div"}>
          <Block className={"subhero-card-inside"} tag={"div"}>
            <Block tag={"div"}>
              <Block className={"subhero-card---title-and-logo"} tag={"div"}>
                <Block className={"icon-wrapper"} tag={"div"}>
                  <Image
                    className={"icon-1x1-medium"}
                    height={"48"}
                    loading={"lazy"}
                    src={icon}
                    width={"48"}
                  />
                </Block>
                <Block className={"title"} tag={"div"}>
                  {title}
                </Block>
              </Block>
              <Block className={"subhero-card-descritpion"} tag={"div"}>
                <Block className={"subhero-card---description"} tag={"div"}>
                  {description}
                </Block>
              </Block>
            </Block>
            <Link
              block={"inline"}
              button={false}
              className={"button is-icon"}
              options={linkLink}
            >
              <Block tag={"div"}>{linkText}</Block>
              <HtmlEmbed
                className={"icon-embed-xsmall"}
                content={
                  '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--heroicons" width="100%" height="100%" preserveaspectratio="xMidYMid meet" viewbox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"/></svg>'
                }
              />
            </Link>
          </Block>
        </Block>
      </Block>
    </Block>
  );
}
